/**
 * @author HungNS
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import en_message from "./en/message";
import en_enums from "./en/enums";
import en_label from "./en/label";
import en_menu from "./en/menu";
import ja_message from "./ja/message";
import ja_enums from "./ja/enums";
import ja_label from "./ja/label";
import ja_menu from "./ja/menu";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ja",
  messages: {
    ja: Object.assign(ja_message, ja_enums, ja_label, ja_menu),
    en: Object.assign(en_message, en_enums, en_label, en_menu)
  },
  fallbackLocale: "ja",
  silentTranslationWarn: true,
});

export default i18n;
